import { apiUrl } from './../../index';
import { setUserImage } from './../../utils/authHelper';
import { AuthActionTypes } from 'src/store/auth/types';
import { alertError } from 'src/store/alert/actions';
import { AxiosResponse } from 'axios';
import { action } from 'typesafe-actions';
import { ImageActionTypes } from './types';
import { uploadImage } from 'src/utils/imageHelper';
import axios from 'axios';

export const uploadImageAction = (type: string, file: File) => {
  interface Response {
    image: any;
  }

  return (dispatch: any) => {
    dispatch(action(ImageActionTypes.UPLOAD_IMAGE));

    uploadImage(type, file, new FormData())
      .then((res: AxiosResponse<Response>) => {
        if (type === 'profile') {
          setUserImage(res.data.image);
        }
        dispatch(action(AuthActionTypes.SET_IMAGE, res.data.image));
        dispatch(action(ImageActionTypes.UPLOAD_SUCCESS, type));
      })
      .catch(err => {
        dispatch(action(ImageActionTypes.UPLOAD_ERROR, err));
        dispatch(alertError(err));
      });
  };
};

export const removeImageAction = (userId: number) => {
  return (dispatch: any) => {
    dispatch(action(ImageActionTypes.UPLOAD_IMAGE));

    axios
      .post(apiUrl + '/user/removeAvatar', { id: userId })
      .then(() => {
        setUserImage(undefined);
        dispatch(action(AuthActionTypes.SET_IMAGE, null));
        dispatch(action(ImageActionTypes.REMOVE_IMAGE));
      })
      .catch(err => {
        dispatch(action(ImageActionTypes.UPLOAD_ERROR, err));
        dispatch(alertError(err));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/image/actions.ts